import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-live-resolution-footer',
  templateUrl: './live-resolution-footer.component.html',
  styleUrls: ['./live-resolution-footer.component.less', './../../poll-vote/poll-vote-footer/poll-vote-footer.component.less']
})
export class LiveResolutionFooterComponent {
  @Input() isMobile: boolean;
  @Input() validButton = true;
  @Output() selected = new EventEmitter<string>();

  actionVoted() {
    this.selected.emit('voted');
  }

  actionCancel() {
    this.selected.emit('cancel');
  }
}
